import script from "./myfooter.vue?vue&type=script&setup=true&lang=js"
export * from "./myfooter.vue?vue&type=script&setup=true&lang=js"

import "./myfooter.vue?vue&type=style&index=0&id=91338ae4&lang=less&scoped=true"

import exportComponent from "/data/jenkins/workspace/pay.7pa.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-91338ae4"]])

export default __exports__